import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CardModel } from "../../../swagger/api.client.generated";
import { CardExpandedComponent } from "./card-expanded.component";

@Injectable({ providedIn: "root" })
export class CardExpandService {
  constructor(private dialog: MatDialog) {}

  open(card: CardModel): MatDialogRef<CardExpandedComponent> {
    return this.dialog.open(CardExpandedComponent, {
      id: "card-expanded",
      data: card,
      panelClass: "card-expanded-panel",
    });
  }
}
